module.exports = __webpack_public_path__ + "static/reflex_diagram-70f69b12e5423365e1642ed0a4703fb6.png";